<template>
  <div id="app">
    <router-view/>
    <!-- <cookie/> -->
    <ExitModal :showModal="showModal" @update-value="update"/>
  </div>
</template>

<script>
// import cookie from "@/plugins/cookie-banner/cookie.vue"
import utmData from "@/plugins/utmdata/index"
import ExitModal from "@/components/modals/ExitModal"
import store from "@/store";
import { getCookie, setCookie } from '@/utils/cookies'

export default {
  mounted() {
    this.$store.dispatch('flats/loadFlats')
    utmData.getUtmData(this.$route.query)
    this.showModalFinance = getCookie('disableFinanceModal') != 1 ? true : false
  },
  components: {
    ExitModal
  },
  data() {
    return {
      showModal: false,
      showModalFinance: false
    }
  },
  computed: {
    locale() {
      return store.state.lang.$locale
    }
  },
  created () {
    document.addEventListener('mouseout', this.modal)
  },
  methods: {
    modal(evt) {
      if (getCookie('disableExitModal') != 1) {
        if (evt.toElement == null && evt.relatedTarget == null) {
          this.showModal = true
        }
      }
    },
    update(value){
      this.showModal = value
    },
    closeModal() {
      setCookie('disableFinanceModal', '1', 14)
      this.showModalFinance = false
    }
  }
}

</script>


<style lang="sass">
$md: 768px
#app 
  font-family: Avenir, Helvetica, Arial, sans-serif
  -webkit-font-smoothing: antialiased
  -moz-osx-font-smoothing: grayscale
  text-align: center
  color: #2c3e50


#nav 
  padding: 30px

  a 
    font-weight: bold
    color: #2c3e50

    &.router-link-exact-active 
      color: #42b983

#finance-modal
  position: fixed
  z-index: 99999
  width: 100%
  height: 100vh
  top: 0
  left: 0
  display: none

  @media (max-width: $md)
    display: block

  .overlay
    background: rgba(0, 0, 0, .5)
    position: absolute
    width: 100%
    height: 100%
    top: 0
    left: 0

    .modal-custom
      height: 80vh
      position: relative
      top: 50px
      padding: 25px

      .content
        height: 100%
        position: relative

        .close-modal
          width: 34px
          height: 34px
          padding: 9px
          position: absolute
          right: 15px
          top: 15px

          img
            width: 100%
            display: block

      .image
        height: 50%
        background: url('assets/images/finance-modal.jpg') no-repeat
        background-size: cover
        background-position: center left

      .box
        position: relative
        padding: 115px 25px 35px
        max-width: 460px
        background: var(--blue)
        .big
          font-size: 40px
          line-height: 44px
          font-weight: 800
          position: absolute
          top: 5px
          left: 25px

        .border-bottom-white
          padding-bottom: 15px
          border-bottom: 1px solid rgba(255, 255, 255, .4)
          margin-bottom: 20px
          font-size: 42px
          line-height: 52px
          font-weight: normal

        .text-dark
          margin-bottom: 0
          font-size: 16px
          font-weight: 400

          a
            font-weight: 600
            color: #343a40
            text-decoration: underline
            
            &::after
              content: ""
              width: 100%
              height: 100%
              position: absolute
              left: 0
              bottom: 0
              cursor: pointer
    
</style>
